import { AiseaApiFactory } from "@/api/aisea/apiFactory";
const radarGridObjectsApi = AiseaApiFactory.get("radarGridObjects");
const SECONDS_IN_ONE_DAY = 24 * 60 * 60 * 1000;

class RadarGridObjectService {
  /**
   * 航跡取得 過去
   * @param {string} radarGridObjectId レーダオブジェクトのid
   * @param {string} options オプション
   * @returns {*} 航跡のデータ
   */
  async pathByRadarGridObjectId(radarGridObjectId, options) {
    return await radarGridObjectsApi.path(radarGridObjectId, options);
  }

  /**
   * 航跡取得 過去 1日分
   * @param {string} radarGridObjectId レーダオブジェクトのid
   * @param {string} options オプション
   * @returns {*} 航跡のデータ
   */
  async pathByRadarGridObjectIdForOneDay(radarGridObjectId, options) {
    const now = new Date();
    const res = await this.pathByRadarGridObjectId(radarGridObjectId, {
      ...options,
      started_at: new Date(now.getTime() - SECONDS_IN_ONE_DAY),
      ended_at: now,
    });
    return res;
  }

  /**
   * 航跡取得 未来
   * @param {string} radarGridObjectId レーダオブジェクトのid
   * @param {string} options オプション
   * @returns {*} 航跡のデータ
   */
  async pathForecast(radarGridObjectId, params) {
    return await radarGridObjectsApi.pathForecast(radarGridObjectId, params);
  }
}

export default new RadarGridObjectService();
